import Instance from './interceptor';
import { API } from '../constants/Constants';
import Toast from '../components/pages/utils/Toast';
import { DOCUMENT_TOAST } from '../constants/toastConstant';

export const getDocumentStatus = async (documentTypes) => {
  try {
    return await Instance.post(`${API.GET_DOCUMENT_STATUS}`, {
      documentTypes,
    });
  } catch (error) {
    if (error?.response?.data) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const getTotalValidatedDocuments = async (documentTypes) => {
  try {
    return await Instance.post(`${API.GET_TOTAL_VALIDATED_DOCUMENTS}`, {
      documentTypes,
    });
  } catch (error) {
    if (error?.response?.data) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const getImportExportDocuments = async (documentTypes) => {
  try {
    return await Instance.post(`${API.GET_IMPORT_EXPORT_STATISTICS}`, {
      documentTypes,
    });
  } catch (error) {
    if (error?.response?.data) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const getUserStatistics = async () => {
  try {
    return await Instance.get(`${API.GET_USER_STATISTICS}`);
  } catch (error) {
    if (error?.response?.data) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const getFlowStatistics = async (documentTypes) => {
  try {
    return await Instance.post(`${API.GET_FLOW_STATISTICS}`, {
      documentTypes,
    });
  } catch (error) {
    if (error?.response?.data) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const getCreditsInfo = async () => {
  try {
    return await Instance.get(`${API.GET_CREDITS_INFO}`);
  } catch (error) {
    if (error?.response?.data) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    }
  }
};

export const getOrganizationPlanDetails = async (
  sorting,
  inputValue,
  filterModel,
  // dropDownValue,
  organizationId,
) => {
  const data = {
    // stage: stageValue,
    searchData: inputValue,
    sortOrder: sorting[0]?.sort,
    sortField: sorting[0]?.colId,
    filterModel,
    organizationId,
    // documentType,
  };
  try {
    const response = await Instance.post(`${API.GET_ORGANIZATION_PLANS}`, data);
    const paymentHistory = response?.data?.data;

    if (paymentHistory?.length === 0) {
      Toast({
        message: DOCUMENT_TOAST.NO_RECORDS,
        variant: 'warning',
        position: { vertical: 'top', horizontal: 'center' },
        autoHideDuration: 4000,
      });
      return paymentHistory;
    }
    return paymentHistory;
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};
